import styled from 'styled-components';
import device from '../../../components/mediaQueries';

const ProductImageCardWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  ${device.desktop`
    text-align: center;
  `}
`;

export default ProductImageCardWrapper;
